export const URL_BASE_SPOTTER = "urlBaseSpotter";
export const ESTA_AMBIENTE_DEV = "ambienteDesenvolvimento";
